import { useMediaQuery } from "@mantine/hooks";

/**
 * Matches Tailwind's desktop-nav breakpoint: hover capability AND min-width 640px.
 * Keep in sync with `desktop-nav` in src/styles/index.css.
 */
const DESKTOP_MEDIA = "(any-hover: hover) and (min-width: 640px)";

export function useIsDesktop(): boolean {
	return useMediaQuery(DESKTOP_MEDIA) === true;
}
